var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrossIcon = function SvgCrossIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 20,
    x: 14.367,
    y: 0.219,
    fill: "#747C94",
    rx: 1,
    transform: "rotate(45 14.367 .219)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 20,
    x: 0.223,
    y: 1.633,
    fill: "#747C94",
    rx: 1,
    transform: "rotate(-45 .223 1.633)"
  })));
};
export { SvgCrossIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0ibm9uZSIgdmlld2JveD0nMCAwIDE2IDE2Jz48cmVjdCB3aWR0aD0iMiIgaGVpZ2h0PSIyMCIgeD0iMTQuMzY3IiB5PSIuMjE5IiBmaWxsPSIjNzQ3Qzk0IiByeD0iMSIgdHJhbnNmb3JtPSJyb3RhdGUoNDUgMTQuMzY3IC4yMTkpIi8+PHJlY3Qgd2lkdGg9IjIiIGhlaWdodD0iMjAiIHg9Ii4yMjMiIHk9IjEuNjMzIiBmaWxsPSIjNzQ3Qzk0IiByeD0iMSIgdHJhbnNmb3JtPSJyb3RhdGUoLTQ1IC4yMjMgMS42MzMpIi8+PC9zdmc+";